import { parsedContent } from '@/lib/utils'

import golfProtect from '~/public/images/golf-club-storage/protect.png'
import golfMaintaining from '~/public/images/golf-club-storage/maintaining.png'
import golfDamage from '~/public/images/golf-club-storage/damage.png'

import skiProtect from '~/public/images/ski-storage/investment.png'
import skiMaintaining from '~/public/images/ski-storage/extend.png'
import skiDamage from '~/public/images/ski-storage/safety.png'

import snowProtect from '~/public/images/snowboard-storage/protect.png'
import snowExtra from '~/public/images/snowboard-storage/extra.png'
import snowEnsure from '~/public/images/snowboard-storage/ensure.png'
import snowAsses from '~/public/images/snowboard-storage/asses.png'
import snowConsider from '~/public/images/snowboard-storage/consider.png'
import snowBudget from '~/public/images/snowboard-storage/budget.png'

const imageClass = {
  wrClassName: 'mt-6 md-mn:pt-0 flex items-end md-mn:items-center lg-mn:items-end md-mn:pl-2 lg-mn:pl-0 '
}

// const appName = Configs.APP_NAME

export const IMPORTANCE = Object.freeze({
  golfClub: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      title: parsedContent(`The Importance of Proper Golf Club Storage`),
      subtitle: parsedContent(
        `
          <p>Golf clubs are valuable equipment that require proper care and maintenance to ensure their longevity and performance. By implementing effective storage practices, golf enthusiasts can protect their investment, maintain club performance, and prevent damage and wear.</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7 ',
      data: [
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: golfProtect,
            alt: 'Protecting your investment',
            wrClassName: imageClass.wrClassName + 'w-[160px] h-[165px]'
          },
          heading: parsedContent('Protecting your investment', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Golf clubs can be a significant financial investment, and proper storage is essential to protect this investment. Storing clubs in a safe and organized manner can help prevent loss or theft, ensuring that your valuable equipment remains secure.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: golfMaintaining,
            alt: 'Maintaining club performance',
            wrClassName: imageClass.wrClassName + 'w-[198px] h-[169px]'
          },
          heading: parsedContent('Maintaining club performance', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Proper storage can also contribute to maintaining the performance of your golf clubs. Storing them in a well-organized manner can prevent unnecessary wear and tear, preserving the club's integrity and ensuring consistent performance on the course.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: golfDamage,
            alt: 'Preventing damage and wear',
            wrClassName: imageClass.wrClassName + 'w-[171px] h-[166px]'
          },
          heading: parsedContent('Preventing damage and wear', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Improper storage can lead to damage such as dents, scratches, or bending of club shafts. By implementing effective storage solutions, golfers can minimize the risk of such damage and prolong the lifespan of their clubs.`
          )
        }
      ]
    }
  },
  skiStorage: {
    // sectionClassName: 'skip-bottom--spacing',
    header: {
      title: parsedContent(`Importance of Proper Ski Storage`),
      subtitle: parsedContent(
        `
          <p>Skiing is an enjoyable winter sport that requires proper equipment. Proper ski storage is essential for protecting your investment. Also, it extends the lifespan of your gear and ensures safety on the slopes.</p>
        `,
        'max-w-[1050px]'
      )
    },
    content: {
      descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7 ',
      data: [
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: skiProtect,
            alt: 'Protecting your investment',
            wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
          },
          heading: parsedContent('Protecting your investment', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Skiing can be an expensive sport, and your ski gear is a significant investment. Proper storage helps protect this investment by preventing damage to your equipment. Storing your skis, boots, and other gear in a safe and organized manner can prevent unnecessary wear and tear, ultimately saving you money in the long run.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: skiMaintaining,
            alt: 'Extending the Lifespan of Your Gear',
            wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
          },
          heading: parsedContent('Extending the Lifespan of Your Gear', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `By storing your ski equipment properly, you can extend its lifespan. Storing skis in a dry, cool place, and keeping them away from extreme temperatures and direct sunlight can prevent warping, delamination, and other damage. Similarly, storing boots in a way that maintains their shape and supports the soles can help prevent premature wear and tear.`
          )
        },
        {
          className: 'md-mn:flex-row lg-mn:flex-col items-center',
          image: {
            src: skiDamage,
            alt: 'Ensuring Safety on the Slopes',
            wrClassName: imageClass.wrClassName + 'w-[260px] h-[150px]'
          },
          heading: parsedContent('Ensuring Safety on the Slopes', 'text-blue-river max-w-full'),
          subheading: parsedContent(
            `Properly stored and maintained ski equipment is essential for your safety on the slopes. Storing skis and boots in a way that keeps them in good condition ensures that they will perform as intended when you're skiing. This can help prevent accidents and injuries that may result from using damaged or improperly maintained gear.`
          )
        }
      ]
    }
  },
  snowboardStorage: {
    top: {
      header: {
        title: parsedContent(`The Importance of Proper Snowboard Storage`),
        subtitle: parsedContent(
          `
          <p>When it comes to snowboarding, proper storage of your gear is essential for several reasons. Whether you're a seasoned rider or a beginner hitting the slopes, maximizing space and protecting your snowboard is crucial for ensuring its longevity and your overall snowboarding experience.</p>
        `,
          'max-w-[1050px]'
        )
      },
      content: {
        descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7 ',
        data: [
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowProtect,
              alt: 'Protecting your investment',
              wrClassName: imageClass.wrClassName + 'w-[190px] h-[160px]'
            },
            heading: parsedContent('Protecting your investment', 'text-blue-river max-w-full'),
            subheading: parsedContent(
              `Snowboards are not just recreational equipment; they are an investment. Proper storage helps protect your snowboard from damage. These damages include dings, scratches, or warping, which can occur if not stored correctly. By investing in the right storage solution, you can ensure that your snowboard remains in top condition for many seasons to come.`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowExtra,
              alt: 'Maximizing Extra Space At Home Or In Your Vehicle',
              wrClassName: imageClass.wrClassName + 'w-[190px] h-[160px]'
            },
            heading: parsedContent('Maximizing Extra Space At Home Or In Your Vehicle', 'text-blue-river max-w-full'),
            subheading: parsedContent(
              `Snowboards can be bulky items, and finding the right storage solution can help you maximize space, whether at home or in your vehicle. With the right storage system, you can keep your snowboard neatly organized and out of the way, freeing up valuable floor space for other activities or gear.`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowEnsure,
              alt: 'Ensuring The Longevity Of Your Snowboard',
              wrClassName: imageClass.wrClassName + 'w-[190px] h-[160px]'
            },
            heading: parsedContent('Ensuring The Longevity Of Your Snowboard', 'text-blue-river max-w-full'),
            subheading: parsedContent(
              `Proper storage also helps ensure the longevity of your snowboard. By keeping it stored in a safe and secure manner, you can prevent unnecessary wear and tear.`
            )
          }
        ]
      }
    },
    bottom: {
      header: {
        title: parsedContent(`Choosing the Right Snowboard Storage Solution`),
        subtitle: parsedContent(
          `
          <p>When choosing a snowboard storage solution, there are several factors to consider to ensure you find the perfect fit for your needs:</p>
        `,
          'max-w-[1050px]'
        )
      },
      content: {
        descriptionWrClass: 'md-mn:grid-cols-1 lg-mn:grid-cols-3 gap-7 ',
        data: [
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowAsses,
              alt: 'Assessing Available Space',
              wrClassName: imageClass.wrClassName + 'w-[248px] h-[181px]'
            },
            heading: parsedContent('Assessing Available Space', 'text-blue-river max-w-full'),
            subheading: parsedContent(
              `Consider the available space in your home, garage, or vehicle to determine the most suitable storage option. Wall-mounted racks may be ideal for those with limited floor space, while freestanding racks are a great choice for larger areas.`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowConsider,
              alt: 'Considering The Number Of Snowboards',
              wrClassName: imageClass.wrClassName + 'w-[248px] h-[181px]'
            },
            heading: parsedContent('Considering The Number Of Snowboards', 'text-blue-river max-w-full'),
            subheading: parsedContent(
              `If you have multiple snowboards, you'll need a storage solution that can accommodate them all. Freestanding racks or overhead storage systems may be the best option for those with a collection of snowboards.`
            )
          },
          {
            className: 'md-mn:flex-row lg-mn:flex-col items-center',
            image: {
              src: snowBudget,
              alt: 'Budget Considerations',
              wrClassName: imageClass.wrClassName + 'w-[248px] h-[181px]'
            },
            heading: parsedContent('Budget Considerations', 'text-blue-river max-w-full'),
            subheading: parsedContent(
              `It's essential to consider your budget when choosing a snowboard storage solution. While there are various options available, it's important to find a solution that fits within your budget while still meeting your storage needs.`
            )
          }
        ]
      }
    }
  }
})
